import React from "react";
import {useStyles} from "./styles/OddStepSevenStyle";

import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import {ReactComponent as CheckPointIcon} from "../../../../../common/images/CheckPointIcon.svg";
import CutTextIcon from "../../../../../common/images/CutTextIcon.svg";

function OddStepSevenDivide(props) {
    const classes = useStyles();

    const {oddStepSevenStore,content} = props;
    const text = content.text;
    const pieceList = content.pieces;

    const handleClick = (index, isMarker) => {
        if (!isMarker) {
            if (pieceList.length === 0) {
                oddStepSevenStore.addPiece(pieceList, {textStartIndex: 0, textEndIndex: index});
                oddStepSevenStore.addPiece(pieceList, {textStartIndex: index + 1, textEndIndex: text.length - 1});
            } else {
                const targetPiece = pieceList.find(piece => piece.textStartIndex <= index && piece.textEndIndex >= index);
                const targetPieceIndex = pieceList.findIndex(piece => piece.textStartIndex <= index && piece.textEndIndex >= index);

                if (targetPiece) {
                    oddStepSevenStore.addPiece(pieceList, {textStartIndex: targetPiece.textStartIndex, textEndIndex: index});
                    oddStepSevenStore.addPiece(pieceList, {textStartIndex: index + 1, textEndIndex: targetPiece.textEndIndex});
                    oddStepSevenStore.removePiece(pieceList, targetPieceIndex);
                    oddStepSevenStore.sortPieceList(pieceList);
                }
            }
        }

        if (isMarker) {
            if (pieceList.length === 2) {
                oddStepSevenStore.removePiece(pieceList, 0);
                oddStepSevenStore.removePiece(pieceList, 0);
            } else {
                const targetPiece = pieceList.find(piece => piece.textEndIndex === index);
                const targetPieceIndex = pieceList.findIndex(piece => piece.textEndIndex === index);

                const afterPiece = pieceList.filter(piece => piece.textStartIndex > targetPiece.textEndIndex).reduce((min, current) => {
                    return current.textStartIndex < min.textStartIndex ? current : min;
                }, pieceList.filter(piece => piece.textStartIndex > targetPiece.textEndIndex)[0]);

                oddStepSevenStore.setPieceTextIndex(afterPiece, targetPiece.textStartIndex, afterPiece.textEndIndex);
                oddStepSevenStore.removePiece(pieceList, targetPieceIndex);
            }
        }
    }

    return (
        <>
            {text.split('').map((char, index) => {
                const isMaker = pieceList.some(piece => piece.textEndIndex === index && (index !== text.length - 1));
                const isSpace = char === ' ';

                return <span
                    style={{paddingRight: isSpace ? '9px' : null, cursor: isMaker ? 'pointer' : 'url(' + CutTextIcon + ') 20 10, auto'}}
                    className={classes.textSpace}
                    onClick={() => handleClick(index, isMaker)}
                    key={index}>
                                {isMaker ? <>{char}<CheckPointIcon/></> : char}
                </span>
            })}
        </>
    );
}

export default withRouter(inject('contentStore','oddStepSevenStore')(observer(OddStepSevenDivide)));
